import React from 'react';
import { useTranslation } from 'react-i18next';

import { ResponsiveModalBottomSheet } from '@/components';

import Button from '../../../components/Button';

interface NoPackageBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const NoPackageBottomSheet: React.FC<NoPackageBottomSheetProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <ResponsiveModalBottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('package.noPackage.title')}
    >
      <div className="px-6 pt-2 pb-8 text-center">
        <div className="mb-6 flex justify-center">
          <img
            src="/illustrations/no-package.png"
            alt="No package found"
            className="h-[200px] w-[200px] object-contain"
            draggable={false}
          />
        </div>
        <h2
          id="no-package-title"
          className="mx-auto mb-8 max-w-[360px] text-lg leading-7 text-black"
        >
          {t('package.noPackage.description')}
        </h2>
        <div className="mx-auto w-full max-w-sm">
          <Button onClick={onClose}>{t('package.noPackage.close')}</Button>
        </div>
      </div>
    </ResponsiveModalBottomSheet>
  );
};

export default NoPackageBottomSheet;
